import React, { useState, useEffect } from 'react';
import { FIREBASE_DB } from '../../lib/firebase/config';
import { enableNetwork, disableNetwork } from 'firebase/firestore';
import { WifiOff } from 'lucide-react';
import Button from './Button';

export default function FirebaseConnectionStatus() {
  const [isOffline, setIsOffline] = useState(false);
  const [isReconnecting, setIsReconnecting] = useState(false);

  useEffect(() => {
    const handleOnline = async () => {
      try {
        setIsReconnecting(true);
        await enableNetwork(FIREBASE_DB);
        setIsOffline(false);
      } catch (error) {
        console.error('Failed to reconnect:', error);
      } finally {
        setIsReconnecting(false);
      }
    };

    const handleOffline = async () => {
      try {
        await disableNetwork(FIREBASE_DB);
        setIsOffline(true);
      } catch (error) {
        console.error('Failed to handle offline:', error);
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4 shadow-lg max-w-sm">
      <div className="flex items-center space-x-3">
        <WifiOff className="h-5 w-5 text-yellow-600" />
        <div className="flex-1">
          <p className="text-sm text-yellow-800">
            You're currently offline. Some features may be limited.
          </p>
        </div>
        {isReconnecting ? (
          <div className="animate-spin h-4 w-4 border-2 border-yellow-600 border-t-transparent rounded-full" />
        ) : (
          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        )}
      </div>
    </div>
  );
}